import { Component, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Extent, layer, source } from 'openlayers';
import { MapComponent } from '../map.component';
import { LayerComponent } from './layer.component';
import { LayerGroupComponent } from './layergroup.component';

@Component({
  selector: 'aol-layer-image',
  template: `<ng-content></ng-content>`
})
export class LayerImageComponent extends LayerComponent implements OnInit, OnChanges {
  public source: source.Image;

  @Input() declare opacity: number;
  @Input() declare visible: boolean;
  @Input() declare extent: Extent;
  @Input() declare minResolution: number;
  @Input() declare maxResolution: number;
  @Input() declare zIndex: number;

  constructor(map: MapComponent, @Optional() group?: LayerGroupComponent) {
    super(group || map);
  }

  override ngOnInit() {
    this.instance = new layer.Image(this);
    super.ngOnInit();
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
